import React from 'react';
import { ARROW_PORT_OFFSET, ARROW_WING_LENGTH } from './ellipsis.tsx';
import { line, move, combinePath } from './lineLeft.tsx';
import { add, invert, multiply, unitDirectionAngle } from './percentageOfLine.tsx';
import { type Point, type PortIndex, toPoint } from './toPortInfo.tsx';
import { toSquareUnitDirection } from './toSquareUnitDirection.tsx';

export interface ArrowProps {
	stroke: string;
	portPosition: Point;
	portIndex: PortIndex;
	portOffset?: number;
}

export const DiagramArrow = ({
	stroke,
	portPosition,
	portIndex,
	portOffset,
}: ArrowProps): React.JSX.Element => {
	const unitDirection = invert(toSquareUnitDirection(portIndex));

	const tip = add(portPosition, multiply(unitDirection, portOffset ?? ARROW_PORT_OFFSET));

	const rotation = unitDirectionAngle(unitDirection);

	const leftWing = add(tip, toPoint(-ARROW_WING_LENGTH, +ARROW_WING_LENGTH));
	const rightWing = add(tip, toPoint(ARROW_WING_LENGTH, ARROW_WING_LENGTH));
	const arrowPath = combinePath(move(leftWing), line(tip), line(rightWing));

	return (
		<path
			fill="none"
			stroke={stroke}
			d={arrowPath}
			strokeWidth="2"
			transform={`rotate(${-rotation} ${tip.x} ${tip.y})`}
		/>
	);
};
